import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Username } from '@imprivata/nucleus';
import headerImage from '../../images/lock.svg';
import * as actions from '../../actions';
import { GetMessageProtocols } from '../../constants/clientProtocols';
import { UNMET_AUTHENTICATION_REQUIREMENTS } from '../../constants/errorCodes';

/**
 * UsernamePage Component
 */
export class UsernamePage extends Component {
  /**
   * The allowed properties for the UsernamePage component
   * @param {function} startAuthSessionOnly The function that begins the authentication session
   * @param {function} startAuthSession The function that begins the authentication session with username and password
   * @param {array} errorCode The original error code
   * @param {array} errorMessage The array of error messages to display
   * @param {bool} isLoading Whether or not something is loading
   * @param {bool} secondFactorError Whether or not there is an error with the second factor authentication credentials
   */
  static propTypes = {
    startAuthSessionOnly: PropTypes.func.isRequired,
    startAuthSession: PropTypes.func.isRequired,
    errorCode: PropTypes.string,
    errorMessage: PropTypes.array,
    isLoading: PropTypes.bool,
    secondFactorError: PropTypes.bool,
    usernameToUse: PropTypes.string,
    isHelpdeskVerificationWorkflow: PropTypes.bool,
    isEpcsWorkflow: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
    isEpcsError: PropTypes.bool,
    errorHandlerUrl: PropTypes.string,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };

  getHeaderTitle = () => {
    if (this.props.isEpcsWorkflow) {
      return 'Sign order';
    }
    else if (this.props.isClinicalWorkflow || this.props.isHelpdeskVerificationWorkflow) {
      return 'Verify identity';
    }
    else {
      return 'Log in';
    }
  };

  getSubmitButtonText = () => {
    if (this.props.enableSubmit) {
      return 'Close';
    }
    else {
      return 'Continue';
    }
  };

  submitForm = data => {
    if (this.props.enableSubmit) {
      window.location.href = this.props.errorHandlerUrl + '?error_code=' + UNMET_AUTHENTICATION_REQUIREMENTS;
    }
    else {
      this.props.startAuthSessionOnly(data.username);
    }
  };

  componentDidMount() {
    if (this.props.initialUsername && this.props.initialPassword) {
      setTimeout( () => this.props.startAuthSession(this.props.initialUsername, this.props.initialPassword), 100);
    }
  }

  render() {
    return (
      <div className='content-body'>
        <Username
          headerTitle={this.getHeaderTitle()}
          isLoading={this.props.isLoading}
          headerImage={headerImage}
          onSubmit={this.submitForm}
          displayErrors={this.props.errorMessage}
          autoFocus={!this.props.usernameToUse}
          logoutComponent={null}
          disableUsernameInput={this.props.disableUsernameInput}
          enableSubmit={this.props.enableSubmit}
          submitText={this.getSubmitButtonText()}
          highlightFields={this.props.secondFactorError}
          initialUsername={this.props.usernameToUse}
          useCustomUX={this.props.useCustomUX}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    isLoading, errorCode, errorMessage, secondFactorError, initialUsername, initialPassword, isEpcsWorkflow,
    errorHandlerUrl, useCustomUX, username, firstAttempt, isClinicalWorkflow, isEntraIdEamIntegration,
    isHelpdeskVerificationWorkflow,
  } = state.login;
  const {
    GetMsgWorkflowNotEnabled, GetMsgWorkflowNotAllowed, GetMsgUserNotFound, GetMsgWorkflowNotAssigned,
  } = GetMessageProtocols;
  const isEpcsError =
      errorCode === GetMsgWorkflowNotEnabled.asString || errorCode === GetMsgWorkflowNotAllowed.asString;
  const isEntraIdEamIntegrationErrorToRedirect =
    isEpcsError || errorCode === GetMsgUserNotFound.asString || errorCode === GetMsgWorkflowNotAssigned.asString;
  const usernameToUse = username ? username : initialUsername;
  const disableUsernameInput = isEntraIdEamIntegration
    || isHelpdeskVerificationWorkflow
    || (isEpcsWorkflow && isEpcsError && errorHandlerUrl)
    || (isEpcsWorkflow && !firstAttempt && usernameToUse !== undefined && usernameToUse !== null && usernameToUse !== '');
  const enableSubmit =
    ( (isEpcsWorkflow && isEpcsError) || (isEntraIdEamIntegration && isEntraIdEamIntegrationErrorToRedirect) )
    && errorHandlerUrl;
  return {
    isLoading,
    errorCode,
    errorMessage,
    secondFactorError,
    usernameToUse,
    isEpcsWorkflow,
    isEpcsError,
    errorHandlerUrl,
    useCustomUX,
    disableUsernameInput,
    isClinicalWorkflow,
    enableSubmit,
    initialUsername,
    initialPassword,
    isHelpdeskVerificationWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startAuthSessionOnly: (username) => {
      dispatch(actions.startAuthSessionOnly(username) );
    },
    startAuthSession: (username, credential) => {
      dispatch(actions.startAuthSession(username, credential) );
    },
  };
};

/* istanbul ignore next */


export default connect(mapStateToProps, mapDispatchToProps)(UsernamePage);
